import React, { useState, useEffect } from 'react';
import BaseForm from '../../app/components/BaseForm';
import Input from '../../app/components/Input';
import CheckBox from '../../app/components/CheckBox';

const FormEditDepartment = ({ isOpen, onClose, title, selectDepartment, onSubmit }) => {
  const [formData, setFormData] = useState({
    nome: '',
    gestores: [],
    disponivel: false,
    responderPara: '',
  });

  const gestoresOptions = [
    { id: 1, nome: 'Adriellen Neves', cargo: 'diretor' },
    { id: 2, nome: 'Allan', cargo: 'gerente' },
    { id: 3, nome: 'Ana Célia', cargo: 'diretor' },
    { id: 4, nome: 'Barbara Lima', cargo: 'gerente' },
    { id: 5, nome: 'Bruna Rodrigues', cargo: 'diretor' },
    { id: 6, nome: 'Celina Rosangela', cargo: 'diretor' },
  ];

  const coresSequencia = [
    { value: '#2837de', label: 'Azul Escuro' },
    { value: '#2979ff', label: 'Azul Claro' },
    { value: '#672c71', label: 'Roxo Escuro' },
    { value: '#a200f2', label: 'Roxo Médio' },
    { value: '#e11970', label: 'Rosa Médio' },
    { value: '#ff66c4', label: 'Rosa Claro' },
    { value: '#008a0b', label: 'Verde Escuro' },
    { value: '#64dd17', label: 'Verde Claro' },
    { value: '#ff6f00', label: 'Laranja' },
    { value: '#ffbd59', label: 'Laranja Médio' },
  ];

  const handleColorSelect = (color) => {
    setFormData((prev) => ({
      ...prev,
      corSequencia: color,
    }));
  };

  useEffect(() => {
    if (selectDepartment) {
      setFormData({
        id: selectDepartment.id || null,
        nome: selectDepartment.nome || '',
        gestores: selectDepartment.gestores || [],
        disponivel: selectDepartment.disponivel || false,
        responderPara: selectDepartment.responderPara || '',
      });
    } else {
      setFormData({
        nome: '',
        gestores: [],
        disponivel: false,
        responderPara: '',
      });
    }
  }, [selectDepartment]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleGestorChange = (gestorId) => {
    const gestorIndex = formData.gestores.indexOf(gestorId);
    let updatedGestores = [...formData.gestores];
    
    if (gestorIndex !== -1) {
      updatedGestores.splice(gestorIndex, 1);
    } else {
      updatedGestores.push(gestorId);
    }
    
    setFormData(prev => ({
      ...prev,
      gestores: updatedGestores
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit && typeof onSubmit === 'function') {
      onSubmit(formData);
    }
  };

  const renderFormFields = () => {
    return (
      <div>
        <div className='pb-4'>
          <Input
            className="mt-2"
            label='Nome:'
            name='nome'
            placeholder="Informe o nome do departamento"
            value={formData.nome}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className='pb-4'>
          <label className="block font-medium mb-2">Usuários gestores:</label>
          <div className="max-h-48 overflow-y-auto border border-gray-300 rounded-tl-2xl rounded-tr-2xl rounded-br-2xl p-4">
            {gestoresOptions.map((gestor) => (
              <div key={gestor.id} className="mb-2">
                <CheckBox
                  checked={formData.gestores.includes(gestor.id)}
                  onChange={() => handleGestorChange(gestor.id)}
                  name={`gestor-${gestor.id}`}
                  title={`${gestor.nome} (${gestor.cargo})`}
                />
              </div>
            ))}
          </div>
        </div>
        
        <div className='pb-4'>
          <CheckBox
            title='Disponível para novas solicitações:'
            onChange={handleCheckboxChange}
            checked={formData.disponivel}
            name='disponivel'
          />
        </div>
        
        <div className='pb-4'>
          <Input
            className="mt-2"
            label='Endereço para responder para:'
            name='responderPara'
            placeholder="E-mail do departamento"
            value={formData.responderPara}
            onChange={handleChange}
            type="email"
          />
        </div>
        <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">Escolha a cor do departamento:</label>
            <div className="flex space-x-2">
              {coresSequencia.map((cor) => (
                <button
                  key={cor.value}
                  type="button"
                  className={`w-10 h-10 rounded-full focus:outline-none transition-all duration-200 transform ${
                    formData.corSequencia === cor.value 
                      ? 'ring-2 ring-offset-2 ring-gray-400 scale-110' 
                      : 'hover:scale-105'
                  }`}
                  style={{ backgroundColor: cor.value }}
                  onClick={() => handleColorSelect(cor.value)}
                  aria-label={`Cor ${cor.label}`}
                />
              ))}
            </div>
            <p className="mt-2 text-xs text-gray-500">Obrigatório a escolha de uma cor.</p>
          </div>
      </div>
    );
  };

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title={title || "Criar Departamento"}
      submitText="Salvar"
      className='max-w-4xl'
    >
      {renderFormFields()}
    </BaseForm>
  );
};

export default FormEditDepartment;